// components/nodes/overlays/overlayRegistry.js
import TestModule from './modules/TestModule';
// import IngestTitleModule from './modules/IngestTitleModule';
import CsJobModule from './modules/CsJobModule';
import ChannelCreate from './modules/ChannelCreate';
import CloudSlicerCentral from './modules/CloudSlicerCentral';
import SmartplayCentral from './modules/SmartplayCentral';
// import FileLoadSimple from './FileLoadSimple';
// import FileLoadOverlay from './FileLoadOverlay';
// import MetadataOverlay from './MetadataOverlay';
// import AdMarkersOverlay from './AdMarkersOverlay';
// import FormInputExample from './FormInputExample';
// import FormContentExample from './FormContentExample';
import InfoSignalSource from './InfoSignalSource';
import SmartplayIngest from './modules/SmartplayIngestModule';
import SmartplayManifestInfo from './modules/SmartplayManifestInfoModule';
import SmartplayIngestVOD from './modules/SmartplayIngestVODModule';
import BitmovinPlayer from './modules/BitmovinPlayer';
import SmartplayVideosList from './modules/SmartplayVideosList';
import SmartplayVideosBitmovin1 from './modules/SmartplayVideosBitmovin1';
import SmartplayVideosBitmovin2 from './modules/SmartplayVideosBitmovin2';
import SmartplayVideosBitmovin3 from './modules/SmartplayVideosBitmovin3';
import SmartplayVideosBitmovin4 from './modules/SmartplayVideosBitmovin4';

export const overlayComponents = {
  // fileLoadSimple: FileLoadSimple,
  BitmovinPlayer: BitmovinPlayer,
  ChannelCreate: ChannelCreate,
  CloudSlicerCentral: CloudSlicerCentral,
  SmartplayCentral: SmartplayCentral,
  CsJobModule: CsJobModule,
  InfoSignalSource: InfoSignalSource,
  // IngestTitleModule: IngestTitleModule,
  TestModule: TestModule,
  SmartplayIngest: SmartplayIngest,
  SmartplayIngestVOD: SmartplayIngestVOD,
  SmartplayManifestInfo: SmartplayManifestInfo,
  SmartplayVideosList: SmartplayVideosList,
  SmartplayVideosBitmovin1: SmartplayVideosBitmovin1,
  SmartplayVideosBitmovin2: SmartplayVideosBitmovin2,
  SmartplayVideosBitmovin3: SmartplayVideosBitmovin3,
  SmartplayVideosBitmovin4: SmartplayVideosBitmovin4,
  // fileLoad: FileLoadOverlay,
  // metadata: MetadataOverlay,
  // adMarkers: AdMarkersOverlay,
  // formInputExample: FormInputExample,
  // formContentExample: FormContentExample,
  none: null, // Add the "none" option
};

// export const overlays = Object.keys(overlayComponents).map((key) => ({
//   value: key,
//   label: key === 'none' ? 'none' : key.charAt(0).toUpperCase() + key.slice(1), // Custom label for "none"
// }));
export const overlays = [
  { value: "placeholder", label: "Select a feature..." },
  ...Object.keys(overlayComponents).map((key) => ({
    value: key,
    label: key === 'none' ? 'none' : key.charAt(0).toUpperCase() + key.slice(1),
  }))
];